<template>
  <section class="ufo-group-workspace">
    <!-- 顶部操作区 -->
    <table-toolbar
      :search.sync="search"
      :show-refresh="true"
      :show-export="true"
      :show-column-settings="true"
      :columns="columnOptions"
      :visible-columns.sync="visibleColumns"
      :default-columns="defaultColumns"
      :fixed-columns="['# ID', 'GroupKey', '操作']"
      @refresh="handleReset"
      @export="handleExport"
    >
      <template slot="left">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleFormAdd" class="btn-action">新增分组</el-button>
      </template>
    </table-toolbar>

    <!-- 表格主体 -->
    <table-page :loading="loading" :empty="tables.length === 0" :show-top-pagination="false" :show-bottom-pagination="false" @retry="fetchData">
      <el-table :data="tables" stripe style="width: 100%" class="premium-table">
        <el-table-column key="col-id" prop="id" label="# ID" width="80">
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-groupKey" prop="groupKey" label="GroupKey" min-width="160">
          <template slot-scope="scope">
            <el-link type="primary" class="cell-name-link" @click="handleFormUpdate(scope.$index, scope.row)">
              {{ scope.row.groupKey }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column key="col-serviceName" v-if="visibleColumns.includes('serviceName')" prop="serviceName" label="ServiceName" min-width="180">
          <template slot-scope="scope">
            <span class="mono-tag" v-if="scope.row.serviceName">{{ scope.row.serviceName }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-nacosNameSpace" v-if="visibleColumns.includes('nacosNameSpace')" prop="nacosNameSpace" label="NacosNameSpace" min-width="180">
          <template slot-scope="scope">
            <span class="mono-tag" v-if="scope.row.nacosNameSpace">{{ scope.row.nacosNameSpace }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-nacosInstanceListUrl" v-if="visibleColumns.includes('nacosInstanceListUrl')" prop="nacosInstanceListUrl" label="NacosInstanceListUrl" min-width="150">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.nacosInstanceListUrl" />
          </template>
        </el-table-column>

        <el-table-column key="col-note" v-if="visibleColumns.includes('note')" prop="note" label="备注" min-width="120">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.note" />
          </template>
        </el-table-column>

        <el-table-column key="col-actions" label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-dropdown @command="cmd => handleActionCommand(cmd, scope.row, scope.$index)" trigger="hover">
              <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit">
                  <i class="el-icon-edit"></i> 编辑分组
                </el-dropdown-item>
                <el-dropdown-item command="delete" style="color: #ef4444;">
                  <i class="el-icon-delete" style="color: #ef4444;"></i> 删除分组
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </table-page>

    <!-- 新增/编辑弹窗 -->
    <form-drawer :visible.sync="dialogVisible" :title="type ? '编辑 UFO 分组' : '新增 UFO 分组'" :icon="type ? 'el-icon-edit-outline' : 'el-icon-plus'" :loading="saveLoading" width="640px" @close="handleCloseDialog" @save="handleSaveDialog">
      <el-form :model="form" label-position="right" label-width="150px" :rules="rules" ref="form" size="small" class="drawer-horizontal-form">
        <el-form-item label="ID" prop="id"><el-input v-model.number="form.id" :disabled="type" placeholder="请输入数字ID"></el-input></el-form-item>
        <el-form-item label="GroupKey" prop="groupKey"><el-input v-model.trim="form.groupKey" placeholder="请输入分组Key"></el-input></el-form-item>
        <el-form-item label="ServiceName" prop="serviceName"><el-input v-model.trim="form.serviceName" placeholder="请输入服务名称"></el-input></el-form-item>
        <el-form-item label="NacosNameSpace" prop="nacosNameSpace"><el-input v-model.trim="form.nacosNameSpace" placeholder="请输入Nacos命名空间"></el-input></el-form-item>
        <el-form-item label="NacosInstanceListUrl" prop="nacosInstanceListUrl"><el-input v-model.trim="form.nacosInstanceListUrl" type="textarea" :rows="3" placeholder="请输入NacosInstanceListUrl"></el-input></el-form-item>
        <el-form-item label="备注" prop="note"><el-input v-model.trim="form.note" type="textarea" :rows="3" placeholder="请输入备注信息（选填）"></el-input></el-form-item>
      </el-form>
    </form-drawer>
  </section>
</template>

<script>
import api from '@/api/channel'
import ExtTextPopover from '@/components/ExtTextPopover/index.vue'
import TableToolbar from '@/components/TableToolbar/index.vue'
import TablePage from '@/components/TablePage/index.vue'
import FormDrawer from '@/components/FormDrawer/index.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'ufoGroup',
  components: { ExtTextPopover, TableToolbar, TablePage, FormDrawer },
  created () {
    this.fetchData()
  },
  computed: {
    id () {
      return this.$store.getters.id
    },
    tables () {
      const search = this.search
      if (search) {
        const keyword = search.toLowerCase()
        return this.tableData.filter(data => {
          return Object.keys(data).some(key => {
            return String(data[key]).toLowerCase().indexOf(keyword) > -1
          })
        })
      }
      return this.tableData
    },
    columnOptions () {
      return [
        { prop: 'serviceName', label: 'ServiceName' },
        { prop: 'nacosNameSpace', label: 'NacosNameSpace' },
        { prop: 'nacosInstanceListUrl', label: 'NacosInstanceListUrl' },
        { prop: 'note', label: '备注' }
      ]
    },
    defaultColumns () {
      return this.columnOptions.map(item => item.prop)
    }
  },
  watch: {
    id (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.fetchData()
    }
  },
  data () {
    return {
      tableData: [],
      envData: {},
      dialogVisible: false,
      loading: false,
      saveLoading: false,
      search: '',
      visibleColumns: ['serviceName', 'nacosNameSpace', 'nacosInstanceListUrl', 'note'],
      form: {
        id: this.id
      },
      AppOptions: [],
      type: false, // 默认状态为新增  true 为修改 false为新增
      index: 0, // 用于修改时保存位置
      rules: {
        id: [{ type: 'number', required: true, message: '请输入数字，且不能为空', trigger: 'blur' }],
        groupKey: [{ type: 'string', required: true, message: '请输入ufo分组', trigger: 'blur' }],
        nacosNameSpace: [{ type: 'string', required: true, message: '请输入NacosNameSpace名称', trigger: 'blur' }],
        nacosInstanceListUrl: [{ type: 'string', required: true, message: '请输入NacosInstanceListUrl', trigger: 'blur' }],
        prefix: [{ type: 'string', required: true, message: '请输入项目前缀', trigger: 'blur' }]
      }
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      api.getUfoGroups().then(res => {
        this.tableData = res
      }).finally(() => {
        this.loading = false
      })
    },
    handleReset () {
      this.search = ''
      this.fetchData()
    },
    handleFormAdd () {
      this.type = false
      const id = this.tableData.length ? this.tableData[this.tableData.length - 1].id : 0
      this.form = {
        id: id + 1
      }
      this.dialogVisible = true
    },
    handleFormUpdate (index, rowData) {
      this.type = true
      this.index = index
      this.form = Object.assign({}, rowData)
      this.dialogVisible = true
    },
    // 提交数据 新增 或 修改
    handleSaveDialog () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveLoading = true
          const params = Object.assign({}, this.form)
          const f = this.type ? api.updateUfoGroup : api.addUfoGroup
          f(params).then(res => {
            if (this.type) {
              this.tableData.splice(this.index, 1, res)
            } else {
              this.tableData.push(res)
            }
            this.$message.success(this.type ? '修改成功' : '添加成功')
            this.dialogVisible = false
          }).finally(() => {
            this.saveLoading = false
          })
        } else {
          return false
        }
      })
    },
    // 删除
    handleFormDelete (id, i) {
      this.$confirm('确定删除吗?', '提示', { type: 'warning' }).then(() => {
        api.deleteUfoGroup(id).then(() => {
          this.tableData.splice(i, 1)
          this.$message.success('删除成功')
        })
      })
    },
    // 操作列下拉菜单分发
    handleActionCommand (command, row, index) {
      if (command === 'edit') {
        this.handleFormUpdate(index, row)
      } else if (command === 'delete') {
        this.handleFormDelete(row.id, index)
      }
    },
    handleExport () {
      const worksheet = XLSX.utils.json_to_sheet(this.tables)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'UFO分组')
      XLSX.writeFile(workbook, `UFO分组-${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`)
    },
    // 关闭弹窗
    handleCloseDialog () {
      this.dialogVisible = false
      if (this.$refs.form) this.$refs.form.clearValidate()
    }
  }
}
</script>

<style scoped>
.ufo-group-workspace {
  padding: 16px 24px;
}

/* 过滤筛选卡片 */
.filter-card {
  margin-top: 0 !important;
  margin-bottom: 20px;
  padding: 16px 24px;
  border-radius: var(--border-radius-card);
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-base);
}

.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-left-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.filter-right-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-action {
  flex-shrink: 0;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 32px;
  padding: 0 16px;
}

.btn-action:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.btn-reset {
  background-color: var(--bg-page) !important;
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  height: 32px;
  padding: 0 16px;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

.btn-reset:hover {
  background-color: var(--bg-hover) !important;
  color: var(--text-main) !important;
  border-color: var(--border-hover) !important;
}

.btn-setting {
  flex-shrink: 0;
  background-color: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  border-radius: 8px !important;
  height: 32px;
  padding: 0 16px;
}

.btn-setting:hover {
  background-color: var(--bg-hover) !important;
  border-color: var(--border-hover) !important;
  color: var(--text-main) !important;
}

.search-input {
  width: 220px;
  flex-shrink: 0;
}

.search-input :deep(.el-input__inner) {
  border-radius: 8px;
  border-color: var(--border-color);
  height: 32px;
  line-height: 32px;
  font-weight: 500;
  background-color: var(--bg-card);
  color: var(--text-main);
  transition: all 0.2s ease;
}

.search-input :deep(.el-input__inner:hover) { border-color: var(--border-hover); }
.search-input :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

/* 列配置 Popover 内部样式 */
.popover-title {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-main);
  padding: 6px 4px;
}

.popover-divider {
  height: 1px;
  background: var(--border-color);
  margin: 6px 0;
}

.popover-body-scroll {
  max-height: 250px;
  overflow-y: auto;
  padding: 4px;
}

.popover-body-scroll::-webkit-scrollbar {
  width: 4px;
}

.popover-body-scroll::-webkit-scrollbar-thumb {
  background: var(--border-hover);
  border-radius: 2px;
}

.popover-body-scroll :deep(.el-checkbox) {
  display: block;
  margin-bottom: 8px;
  margin-right: 0;
}

/* 表格卡片 */
.table-card {
  padding: 20px;
  border-radius: var(--border-radius-card);
  background-color: var(--bg-card);
  border: 1px solid var(--border-light);
  box-shadow: var(--shadow-base);
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  color: var(--text-main) !important;
}

.premium-table::before { display: none !important; }

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right .el-table__fixed-header-wrapper) th {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) { transition: background-color 0.2s ease; }
.premium-table :deep(.el-table__row:hover) td,
.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

.cell-id,
.cell-text-gray {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
}

.cell-id {
  font-weight: 600;
  color: var(--text-muted);
}

.cell-text-gray {
  color: var(--text-muted);
}

.cell-name-link {
  font-size: 13.5px !important;
  font-weight: 700 !important;
  text-decoration: none !important;
}

/* 等宽 Tag */
.mono-tag {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  background: var(--bg-hover);
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
}

/* 查看链接 */
.view-link {
  font-size: 13px;
  font-weight: 500;
}

.view-link.muted {
  color: var(--text-muted) !important;
}

.text-muted { color: var(--text-muted); font-size: 13px; }

/* 操作列三点按钮 */
.action-btn {
  font-size: 12px;
  border: 1px solid var(--border-color);
  color: var(--text-muted);
  background: var(--bg-card);
  transition: all 0.2s ease;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: var(--bg-hover);
  color: var(--text-main);
  border-color: var(--border-hover);
}

/* 弹窗 */
.premium-dialog :deep(.el-dialog) {
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  background-color: var(--bg-card) !important;
}

/* 表单 */
.ufo-premium-form :deep(.el-form-item__label) {
  font-weight: 600;
  color: var(--text-main);
  padding-bottom: 6px !important;
}

.ufo-premium-form :deep(.el-input__inner) {
  border-radius: 6px;
  border-color: var(--border-color);
  background-color: var(--bg-card);
  color: var(--text-main);
}

.ufo-premium-form :deep(.el-input__inner:focus),
.ufo-premium-form :deep(.el-textarea__inner:focus) {
  border-color: var(--primary-color);
}

.ufo-premium-form :deep(.el-textarea__inner) {
  border-radius: 6px;
  border-color: var(--border-color);
  background-color: var(--bg-card);
  color: var(--text-main);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
}

.btn-save {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.btn-save:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}
</style>
